import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RuleEngineService {

  private _controller = 'rule-config';

  constructor(private _http: HttpClient) { }

  get(): Observable<any>{
    return this._http.get<any>(this._controller);
  }

  update(data: boolean): Observable<Object> {
    return this._http.put<Object>(this._controller + '/' + ((data)?'1':'0'), '');
  }

}